"use client";

import React from "react";
import { Facebook, Instagram, ArrowUp, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-secondary hover:text-primary transition-colors duration-300 font-mono text-sm uppercase tracking-wider">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socialLinks = [{
    icon: Instagram,
    href: "https://instagram.com/sterlinglaw",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "https://facebook.com/sterlinglaw",
    label: "Facebook"
  }];
  return <section data-section-id="265023" id="footer" className="bg-background text-foreground pt-20 pb-8 px-6 md:px-12 border-t border-primary">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-10 w-auto text-foreground" />
            </Link>
            <p className="text-secondary font-serif text-sm leading-relaxed max-w-xs italic">
              Sterling Law Associates provides unshakeable stability and elite legal intelligence, specializing in family law and real estate with architectural precision.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-bold tracking-tight text-foreground">Navigation</h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-bold tracking-tight text-foreground">The Firm</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-secondary">
                <MapPin className="w-5 h-5 shrink-0 mt-0.5 text-primary" />
                <span className="font-sans text-sm">100 Sterling Plaza, Financial District, New York, NY</span>
              </li>
              <li className="flex items-center space-x-3 text-secondary">
                <Phone className="w-5 h-5 shrink-0 text-primary" />
                <span className="font-sans text-sm">+1 (212) 555-0198</span>
              </li>
              <li className="flex items-center space-x-3 text-secondary">
                <Mail className="w-5 h-5 shrink-0 text-primary" />
                <span className="font-sans text-sm">counsel@sterlinglaw.com</span>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="font-default text-xl font-bold tracking-tight text-foreground">Connect</h3>
            <p className="text-secondary font-sans text-sm mb-2">
              Follow our legal insights and stay informed on the latest regulatory developments.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, i) => <Link key={social.label} data-index={i} to={social.href} newTab className="w-10 h-10 rounded-md bg-muted flex items-center justify-center text-secondary hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md hover:shadow-lg" aria-label={social.label}>
                  <social.icon className="w-5 h-5" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-primary/30 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-secondary font-mono text-xs uppercase tracking-widest">
            &copy; {new Date().getFullYear()} Sterling Law Associates. Legal Notice.
          </p>
          
          <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-md border-secondary hover:border-primary hover:text-primary transition-colors duration-300 shadow-sm" aria-label="Back to top">
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>;
}